import React from 'react';
import ModalButton from 'components/ModalButton/ModalButton';
import autoRenewIcon from 'assets/images/icons/auto-renew.svg';
import CommonLargeModal from 'components/Modals/CommonLargeModal';

interface OptOutConfirmationModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  // The opt-out is saved from here now, so the confirm has an in-flight state.
  saving?: boolean;
}

const OptOutConfirmationModal = ({ show, onConfirm, onCancel, saving = false }: OptOutConfirmationModalProps) => (
  <CommonLargeModal
    show={show}
    onHide={onCancel}
    title={<img src={autoRenewIcon} alt="Auto renewal icon" />}
  >
    <h4 className="mb-3 fw-bold fs-4" style={{ color: '#47474a' }}>What this means for you…</h4>
    <p className="fs-6">If you choose to opt out, you’ll need to contact us to renew your breakdown cover.</p>
    <p className="fs-6">
      But with auto-renewal, you’ll have peace of mind that you’re always covered.
      We’ll remind you before your renewal and you can change your mind at any time.
    </p>
    <p className="fs-6 fw-bold mb-4">Are you sure you want to opt out?</p>

    <ModalButton type="button" onClick={onConfirm} variant="filled-grey" disabled={saving} data-testid="opt-out-confirm">
      {saving ? <i className="fas fa-spinner fa-pulse" /> : 'Yes please'}
    </ModalButton>

    <ModalButton type="button" variant="filled" onClick={onCancel} disabled={saving}>
      No thanks
    </ModalButton>
  </CommonLargeModal>
);

export default OptOutConfirmationModal;
